import styled from "styled-components"

export const Container = styled.header<{ tempRemoveComponents: boolean }>`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 20px;
  width: 100%;
  background: linear-gradient(
    180deg,
    rgba(11, 10, 13, 0.8) 0%,
    rgba(29, 29, 29, 0) 100%
  );
  position: absolute;
  top: 32px;
  opacity: ${({ tempRemoveComponents }) => (tempRemoveComponents ? 0 : 1)};
  transition: opacity 3s;
  @media only screen and (min-width: 400px) {
    gap: 24px;
  }
  @media only screen and (min-width: 768px) {
    top: 38px;
    gap: 0;
  }
  @media only screen and (min-width: 1024px) {
    flex-direction: column;
    right: -2px;
    width: unset;
    top: 0px;
    border-radius: 4px;
    /* background: rgba(29, 29, 29, 0.); */
    background: linear-gradient(
      -90deg,
      rgba(11, 10, 13, 0.6) 30%,
      rgba(29, 29, 29, 0) 100%
    );
    /* gap: 14px; */
    padding: 15px;
  }
`
